import { BaseEntity } from './BaseEntity'

export class RHDigitalDepartmentEntity extends BaseEntity {
    constructor() {
        super()

        this.entityName = 'components.rhdigital.list.departments.entity'
        this.APIRoute = 'Resources/RHDigital/Departments'
        this.i18nBase = 'components.rhdigital.list.departments'
        this.customActions = { duplicate: false }

        this.tableColumns = [
            { key: 'logo', label: 'components.rhdigital.list.fields.logo', visible: true, orderBy: false, width: '10px' },
            { key: 'nome', label: 'components.rhdigital.list.fields.nome', visible: true, width: '90px', orderBy: true },
            { key: 'nomeFantasia', label: 'components.rhdigital.list.fields.nomeFantasia',  width: '90px', visible: true, orderBy: true },
            { key: 'slug', label: 'components.rhdigital.list.fields.slug', visible: true,  width: '90px', orderBy: true },
            { key: 'timezone', label: 'components.rhdigital.list.fields.timezone', visible: true, width: '90px', orderBy: true },
            { key: 'status', label: 'common.labels.status', visible: true, orderBy: false },
            { key: 'actions', label: 'common.labels.actions', visible: true, orderBy: false },
        ]

        this.pages = {
            create: { route: ['/rhdigital/departments'] },
            edit: { route: ['/rhdigital/departments'] },
            list: {
                pageTitle: 'components.rhdigital.list.departments.title',
                pathI18n: 'components.settings.permissionManagement.menuList.Departments',
                route: ['/rhdigital/departments'],
                filters: {
                    quickSearch: {
                        info: 'common.messages.info.searchByName',
                        searchBy: ['nome'],
                        type: 'text',
                    },
                    advanced: {
                        fields: [
                            {
                                key: 'status',
                                label: 'common.labels.status',
                                type: 'select',
                                options: [
                                    { label: 'common.labels.active', value: true },
                                    { label: 'common.labels.inactive', value: false },
                                ],
                                path: 'status',
                            },
                        ],
                    },
                },
            },
        }
    }

    getUrl(endpoint, params = {}) {
        let url = endpoint
        Object.keys(params).forEach((key) => {
            url = url.replace(`:${key}`, params[key])
        })
        return url
    }
}
